module.exports = __webpack_public_path__ + "img/goods.86d93ee4.png";